var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144 0H0V144H144V0Z",
    fill: "#004D47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7509 89.3982L95.5123 37.2701L79.701 80.0093L71.3061 33.8142L62.9112 80.0093L47.0999 37.2701L45.8613 89.3982L26.0896 47.1483L33.0166 110.638H71.3061H109.596L116.507 47.1483L96.7509 89.3982Z",
    fill: "#D32737"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.678 118.681H33.5667C30.2026 118.681 27.4502 115.929 27.4502 112.565V110.47C27.4502 107.106 30.2026 104.353 33.5667 104.353H108.678C112.042 104.353 114.794 107.106 114.794 110.47V112.565C114.794 115.929 112.042 118.681 108.678 118.681Z",
    fill: "#FFDD00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.353 50.742C33.353 53.999 30.7229 56.6291 27.4658 56.6291C24.2088 56.6291 21.5786 53.999 21.5786 50.742C21.5786 47.4849 24.2088 44.8548 27.4658 44.8548C30.7229 44.8548 33.353 47.4849 33.353 50.742Z",
    fill: "#00C8B7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.63 50.742C121.63 53.999 119 56.6291 115.743 56.6291C112.486 56.6291 109.856 53.999 109.856 50.742C109.856 47.4849 112.486 44.8548 115.743 44.8548C119 44.8548 121.63 47.4849 121.63 50.742Z",
    fill: "#00C8B7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3847 39.931C53.3847 43.6162 50.3875 46.6133 46.7023 46.6133C43.0171 46.6133 40.02 43.6162 40.02 39.931C40.02 36.2458 43.0171 33.2487 46.7023 33.2487C50.3875 33.2487 53.3847 36.2458 53.3847 39.931Z",
    fill: "#00C8B7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.072 39.931C102.072 43.6162 99.0748 46.6133 95.3896 46.6133C91.7044 46.6133 88.7073 43.6162 88.7073 39.931C88.7073 36.2458 91.7044 33.2487 95.3896 33.2487C99.0748 33.2487 102.072 36.2458 102.072 39.931Z",
    fill: "#00C8B7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4286 25.1747L63.0184 29.2269L60.9387 38.3406L66.7648 45.6498H76.1078L81.9338 38.3406L79.8542 29.2269L71.4286 25.1747Z",
    fill: "#00C8B7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6657 95.8513C48.8587 102.381 62.4221 103.405 66.566 93.9552C67.7893 91.1569 63.6759 88.7256 62.4373 91.5392C59.532 98.145 50.2807 96.9217 46.045 92.4567C43.9195 90.2241 40.5402 93.6035 42.6657 95.836",
    fill: "#004D47"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M97.913 92.4567C93.6773 96.9217 84.426 98.145 81.5206 91.5392C80.282 88.7256 76.1534 91.1569 77.392 93.9552C81.5359 103.405 95.0993 102.365 101.292 95.8513C103.418 93.6188 100.039 90.2241 97.913 92.472",
    fill: "#004D47"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7974 109.552C54.3176 114.537 63.0336 116.755 70.2664 117.259C79.1354 117.871 88.2031 115.088 95.0231 109.399C97.3932 107.427 93.9985 104.063 91.6437 106.02C85.7718 110.898 77.805 112.978 70.2664 112.473C66.8105 112.244 63.3699 111.387 60.0823 110.271C57.3299 109.338 54.3481 108.146 52.1767 106.173C49.8983 104.109 46.5037 107.488 48.7974 109.552Z",
    fill: "#004D47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/Crown.8f9c93a140cda2fe402d93ee88ece637.svg";
export { ForwardRef as ReactComponent };